import React, { FC } from 'react';
import { ICustomIconProps } from './interfaces';
import { CUSTOM_ICONS_MAP } from './constants';

export const CustomIcon: FC<ICustomIconProps> = ({ name, ...props }) => {
  const IconElement = CUSTOM_ICONS_MAP.get(name) || CUSTOM_ICONS_MAP.get('no-name-card')!;

  return <IconElement {...props} />;
};
